import Announce2nd from './announce2nd';

import Typewriter from "typewriter-effect/dist/core";

export default class Loader {
    constructor() {
        this.announce2nd = new Announce2nd();
        this.init();
    }

    init() {
        const logoanimelm = document.querySelector(".js-logoanimelm");
        const tr = new Typewriter(".loader__logotxt", { delay: 20 });
        const logosrc = "/tv/assets/img/page/top/mainvisual/ph_logo_anim_y.png";
        const countdown = document.getElementById("countdown__modal");
        const announce = document.getElementById("announce2nd__modal");

        setTimeout(() => {
            tr.typeString("MANGA TIME<br />KR COMICS<br />BOCCHI<br />THE“GUITAR HERO”<br />ROCK STORY").start();
        }, 2500);

        setTimeout(() => {
            document.body.classList.add("-introend");
            document.querySelector('.mainvisual').classList.add('-change');
            logoanimelm.setAttribute("src", logosrc);
        }, 4500);

        if (countdown) {
            setTimeout(() => {
                countdown.classList.add("-active");
                document.body.classList.add("-lock");
            }, 6500);
        }

        if (announce) {
            setTimeout(() => {
                announce.classList.add("-active");
                document.body.classList.add("-lock");
                this.announce2nd.startAnimation();
            }, 6500);
        } else {

        }

        document.body.setAttribute("data-introtheme", Math.floor(Math.random() * 4) + 1);
        //document.body.setAttribute("data-introtheme", 3);
    }
}